import { render } from "./Modal.vue?vue&type=template&id=932b772a"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=932b772a&lang=scss"
script.render = render

export default script